import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("giva_lang") || "en");

  const setLang = useCallback((l) => {
    localStorage.setItem("giva_lang", l);
    document.documentElement.lang = l;
    setLangState(l);
  }, []);

  const t = useCallback(
    (key) => {
      const dict = translations[lang] || translations.en;
      const value = key.split(".").reduce((o, k) => (o == null ? undefined : o[k]), dict);
      return value === undefined ? key : value;
    },
    [lang]
  );

  return <I18nContext.Provider value={{ t, lang, setLang }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
